import './style.scss';
import {gsap} from 'gsap';
import {Flip} from 'gsap/Flip';

gsap.registerPlugin(Flip);
export function about_us_block() {
    const block = document.querySelector('.about_us_block');
    if (!block) return;
    
    const title = block.querySelector('.title');
    const titleSvg = block.querySelector('.title svg');
    const state = Flip.getState(title);
    
    gsap.set(title, {
        position: "fixed",
        top: "50%", left: "50%",
        xPercent: -50, yPercent: -50,
        zIndex: 10,
        rotation: 0,
        scale: 2,
        transformOrigin: "50% 50%"
    });
    
    gsap.timeline({delay:2})
        .from(titleSvg, {scale:2, transformOrigin:'right bottom'})
        .from(title.querySelector('span'), {opacity:0},'<')
        .add(Flip.to(state, {
            ease: "power3.out",
            absolute: true,
            scale: true,
            zIndex:10,
            duration: 1.5
        }), "+=.5")
        .from('.description-card',{backgroundColor: 'rgba(45, 23, 31,0)'},'<+=50%')
        .from('.description > *:not(.title)',{opacity: 0},'<')
        .from('.outline', {xPercent: 100},'<')
}
